<template>
  <div class="detail-box">
    <div class="result-box">
      <div @click="onRestart"
        class="assess-box">
        <div class="assess-title">您的测评结果</div>
        <div class="assess-btn">重新测评</div>
      </div>
      <!-- <div class="kind-box">
        <img class="ic-shield"
          src="../../assets/detail/ic_shield.png">
        <div class="kind-text">高危人群</div>
      </div>
      <div class="process-title">妊娠糖尿病风险测评：</div>
      <div class="process-box">
        <div class="risk-box">
          <div>
            <img src="../../assets/detail/ic_risk_low.png"
              class="ic-risk">
            <div>低危</div>
          </div>
          <div>
            <img src="../../assets/detail/ic_risk_normal.png"
              class="ic-risk">
            <div>中危</div>
          </div>
          <div>
            <img src="../../assets/detail/ic_risk_hight.png"
              class="ic-risk">
            <div>高危</div>
          </div>
        </div>
      </div> -->
      <div v-html="form.resultHtml"
        class="result-text">
      </div>
    </div>
    <template v-if="form.proposeHtml">
      <div class="topic-box">
        <img v-if="customContent.propose.icon"
          :src="customContent.propose.icon"
          class="topic-ic">
        <div class="topic-text">{{customContent.propose.title || '建议'}}</div>
      </div>
      <div v-html="form.proposeHtml"
        class="topic-content">
      </div>
    </template>
    <template v-if="form.recommend">
      <div class="topic-box">
        <img v-if="customContent.recommand.icon"
          :src="customContent.recommand.icon"
          class="topic-ic">
        <div class="topic-text">{{customContent.recommand.title || '推荐'}}</div>
      </div>
      <div v-html="form.recommend"
        class="topic-content">
      </div>
    </template>
    <div v-if="form.preventionUrl"
      @click="onPlan"
      class="btn-box">
      <div class="btn">查看解决方案</div>
    </div>
  </div>
</template>

<script>
import { actions, injectMixins } from '@/services'
import { isEmptyObject, isWeixin } from '@/helpers'
import sensors from '@/utils/sensors'

export default {
  mixins: [
    injectMixins
  ],
  data () {
    return {
      form: {},
      isWeixin: isWeixin(),
      customContent: {
        result: {
          icon: '',
          title: '测评结果'
        },
        propose: {
          icon: '',
          title: '建议'
        },
        recommand: {
          icon: '',
          title: '推荐'
        }
      }
    }
  },
  mounted () {
    document.documentElement.scrollTop = 0
    document.title = '测评结果'
    // 获取问答详情
    this.getUserLastedAssess()
  },
  methods: {
    // 获取问答详情
    async getUserLastedAssess () {
      const key = this.$route.query.key
      const ret = await actions.getUserLastedAssess(this.code, key)
      if (ret.code === 200 && ret.data) {
        this.form = ret.data || {}
      } else {
        const tmpChatResult = this.gState && this.gState.tmpChatResult
        this.form = tmpChatResult || {}
      }
      // customContent转为json格式
      const { customContent } = this.form
      if (customContent) {
        this.customContent = JSON.parse(customContent)
      }
    },
    // 解决方案
    onPlan () {
      // 神策埋点
      const sensorConfig = {
        app_title: document.title,
        url: location.href,
        app_button: '查看解决方案'
      }
      sensors.appWebClick(sensorConfig)
      const b = window.__oneLiteBridge
      if (b && b.connected) {
        b.navigateUrl(this.form.preventionUrl)
      } else {
        window.location.href = this.form.preventionUrl
      }
    },
    // 重新测评
    onRestart () {
      this.$router.push({ path: `/survey/chat?code=${this.cpCode}` })
    }
  }
}
</script>

<style lang="scss">
.detail-box {
  background-color: #ffffff;
  box-sizing: border-box;
  min-height: 100vh;
  padding: 18px 10px 80px 10px;
  .result-box {
    background: url(../../assets/detail/bg_shield.png) no-repeat;
    background-size: 95px 110px;
    background-position: top right;
    background-color: #f1f8fe;
    border-radius: 9px;
    padding: 21px 13px;
    .assess-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .assess-title {
        font-size: 12px;
        font-weight: 500;
      }
      .assess-btn {
        background-color: #e7f0f7;
        border-radius: 13px;
        color: #9d9d9d;
        font-size: 14px;
        padding: 3px 12px;
        &:active {
          opacity: 0.5;
        }
      }
    }
    .kind-box {
      display: flex;
      align-items: center;
      padding-top: 20px;
      .ic-shield {
        height: 27px;
        width: 21px;
      }
      .kind-text {
        font-size: 20px;
        font-weight: 500;
        padding-left: 9px;
      }
    }
    .process-title {
      font-size: 13px;
      padding-top: 22px;
    }
    .process-box {
      background: url(../../assets/detail/bg_process.png) no-repeat;
      background-size: 100%;
      background-position: 100% 5px;
      margin-top: 9px;
      position: relative;
      .risk-box {
        color: #7e7e7e;
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        padding: 0 13px;
        text-align: center;
        .ic-risk {
          height: 20px;
          width: 20px;
        }
      }
    }
    .result-text {
      font-size: 15px;
      font-weight: 500;
      padding-top: 20px;
    }
  }
  .topic-box {
    display: flex;
    align-items: center;
    padding: 43px 13px 14px 13px;
    .topic-ic {
      height: 21px;
      width: 19px;
    }
    .topic-text {
      color: #343434;
      font-size: 17px;
      font-weight: 500;
      padding-left: 12px;
    }
  }
  .topic-content {
    padding: 0 13px;
    img {
      width: 100%;
    }
    // * {
    //   color: #343434;
    //   font-size: 13px;
    //   font-weight: 400;
    // }
  }
  .btn-box {
    background-color: #ffffff;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 0 27px 30px 27px;
    width: 100%;
    .btn {
      background-color: #3dd3cb;
      border-radius: 21px;
      color: #ffffff;
      font-size: 15px;
      padding: 5px 0;
      text-align: center;
    }
  }
}
</style>
